import { useState } from "react";
import { Card, InputNumber, Space, Tag } from "antd";
import { classifyLoad, LOAD_STATUS_COLORS } from "../../utils/fsrUtils";

const OverloadCalculatorSection = () => {
  const [load, setLoad] = useState(null);

  const result = typeof load === "number" ? classifyLoad(load) : null;

  return (
    <Card title="Overload/Underload Unit Calculator">
      <Space align="center" size="middle">
        <InputNumber
          placeholder="Enter Load"
          min={0}
          value={load}
          onChange={setLoad}
          style={{ width: 160 }}
        />
        {result && (
          <Tag color={LOAD_STATUS_COLORS[result.status]}>
            {result.status}
            {result.units > 0 ? ` — ${result.units} unit(s)` : ""}
          </Tag>
        )}
      </Space>
    </Card>
  );
};

export default OverloadCalculatorSection;
